import { FiltersStateType } from "src/pages/DashboardPage/acadia/type";

export function isDocFiltersEmpty(filters: FiltersStateType): boolean {
  const arrayKeys: (keyof FiltersStateType)[] = [
    "collections",
    "departments",
    "sectors",
    "processes",
    "types",
    "critical",
    "lines",
    "sap",
    "typeEquipment",
    "model",
    "manufacturer",
    "titleEquipment",
    "workstations",
    "responsibleForRevision",
    "created",
    "templateOWD",
    "notificationStatus",
    "notificationType",
  ];
  const hasArrayFilter = arrayKeys.some((key) => (filters[key] as unknown[]).length > 0);
  const hasDateFilter =
    filters.dateForRevision?.required || !!filters.dateForRevision?.date?.start || !!filters.dateForRevision?.date?.end;
  return !hasArrayFilter && !hasDateFilter;
}
